var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidesAndStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#FDF3E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 15H35V35H36V15Z",
    fill: "#C8C7CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16C40.3331 17.3333 37.6669 18.6667 35 20C35 17.3333 35 14.6667 35 12C37.6669 13.3333 40.3331 14.6667 43 16Z",
    fill: "#219653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17C30 20.8654 26.8654 24 23 24C19.1346 24 16 20.8654 16 17C16 13.1346 19.1346 10 23 10C26.8654 10 30 13.1346 30 17Z",
    fill: "#FFB636"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33C36 33 32.425 26 23 26C13.575 26 10 33 10 33V36H36V33Z",
    fill: "#62ACFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesAndStaff);
export default __webpack_public_path__ + "static/media/guides_and_staff.f667d140.svg";
export { ForwardRef as ReactComponent };